import { render, staticRenderFns } from "./Shoutout.vue?vue&type=template&id=f6d5bbc8"
import script from "./Shoutout.vue?vue&type=script&lang=js"
export * from "./Shoutout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports